/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Duration_InvalidInputs */

const vi_error_shop_duration_invalid = /** @type {(inputs: Error_Shop_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời lượng video không hợp lệ — hãy chọn lại video.`)
};

/**

* @param {Error_Shop_Duration_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_duration_invalid = /** @type {((inputs?: Error_Shop_Duration_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Duration_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_duration_invalid(inputs)
});